import { TypographyVariant, useTheme } from '@mui/material'
import Box, { BoxProps } from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export function Tag({
  label,
  variant = 'primary',
  typoVariant = 'body',
  ...props
}: { label: string; variant?: 'primary' | 'secondary'; typoVariant?: TypographyVariant } & BoxProps) {
  const theme = useTheme()
  return (
    <Box
      width="fit-content"
      display="flex"
      borderRadius={theme.radius.full}
      padding={`0 ${theme.spacing.XXL}`}
      alignItems="center"
      justifyContent="center"
      bgcolor={variant === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main}
      {...props}
    >
      <Typography
        sx={{ '&.MuiTypography-root': { lineHeight: '20px' } }}
        height="20px"
        color={theme.palette.text.inverse}
        variant={typoVariant}
        textAlign="center"
      >
        {label}
      </Typography>
    </Box>
  )
}
